'use client'

import { ext } from '@/utils/linkTarget'
import Container from '@/components/templates/container'
import Spacer from '@/components/atoms/spacer'

const ClassCard = ({ item }) => (
  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-smallMobile md:gap-mediumDesktop border-t border-dune py-smallMobile lg:py-smallDesktop">
    {/* Left: title + description */}
    <div className="flex flex-col gap-detailsDesktop">
      <p className="text-body2Mobile md:text-body2Desktop font-ttDrugsTrial text-olive">
        {item.title}
      </p>
      {item.description && (
        <p className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-khaki">
          {item.description}
        </p>
      )}
      {item.coach?.name && (
        <p className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-khaki">
          {item.coach.name}
          {item.coach.role ? ` — ${item.coach.role}` : ''}
        </p>
      )}
    </div>

    {/* Right: details + price */}
    <div className="flex flex-col gap-detailsDesktop">
      {item.details?.schedule && (
        <div className="flex gap-smallMobile">
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-khaki uppercase tracking-widest w-[80px] shrink-0">Schedule</span>
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-olive">{item.details.schedule}</span>
        </div>
      )}
      {item.details?.duration && (
        <div className="flex gap-smallMobile">
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-khaki uppercase tracking-widest w-[80px] shrink-0">Duration</span>
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-olive">{item.details.duration}</span>
        </div>
      )}
      {item.details?.level && (
        <div className="flex gap-smallMobile">
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-khaki uppercase tracking-widest w-[80px] shrink-0">Level</span>
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-olive">{item.details.level}</span>
        </div>
      )}
      {item.details?.groupSize && (
        <div className="flex gap-smallMobile">
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-khaki uppercase tracking-widest w-[80px] shrink-0">Group</span>
          <span className="text-bodyMobile md:text-bodyDesktop font-chivoMono text-olive">{item.details.groupSize}</span>
        </div>
      )}
      {item.price && (
        <p className="text-bodyMobile md:text-bodyDesktop font-ttDrugsTrial text-umber mt-detailsDesktop">
          {item.price}
        </p>
      )}
    </div>
  </div>
)

const ClassesSection = ({ classes, heading }) => {
  if (!classes?.length) return null

  const rezervClass = classes.find(c => c.ctaButton?.link)
  const rezervLink = rezervClass?.ctaButton?.link
  const rezervLabel = rezervClass?.ctaButton?.name || 'Book via Rezerv'

  const whatsappClass = classes.find(c => c.whatsappLink)
  const whatsappLink = whatsappClass?.whatsappLink
  const whatsappLabel = whatsappClass?.whatsappLabel || 'Book via WhatsApp'

  return (
    <Container outerClassName="my-largeMobile lg:my-largeDesktop">
      <Spacer />
      <div className="flex flex-col mt-mediumMobile lg:mt-mediumDesktop">
        {/* Header: heading left, buttons right */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-smallMobile mb-smallMobile lg:mb-smallDesktop">
          {heading && (
            <h2 className="text-subheadingMobile md:text-subheadingDesktop font-ttDrugsTrial text-olive">
              {heading}
            </h2>
          )}
          <div className="flex flex-wrap gap-detailsDesktop shrink-0">
            {rezervLink && (
              <a
                href={rezervLink}
                {...ext(rezervLink)}
                className="inline-flex items-center px-smallMobile py-[10px] border border-olive text-bodyMobile md:text-rectangleButtonDesktop font-chivoMono text-olive uppercase tracking-[3.2px] hover:bg-olive hover:text-background transition-colors duration-300 whitespace-nowrap"
              >
                {rezervLabel}
              </a>
            )}
            {whatsappLink && (
              <a
                href={whatsappLink}
                {...ext(whatsappLink)}
                className="inline-flex items-center px-smallMobile py-[10px] bg-olive text-bodyMobile md:text-rectangleButtonDesktop font-chivoMono text-background uppercase tracking-[3.2px] hover:bg-umber transition-colors duration-300 whitespace-nowrap"
              >
                {whatsappLabel}
              </a>
            )}
          </div>
        </div>

        {/* Class rows */}
        {classes.map((item, i) => (
          <ClassCard key={i} item={item} />
        ))}

        {/* Bottom border to close the last row */}
        <div className="border-t border-dune" />
      </div>
    </Container>
  )
}

export default ClassesSection
